import { supabase } from '@/core/database/supabase';
import type { UserProfileDetail } from '../types/userDetail.types';

export const UserDetailService = {
 async getUserDetail(id: string): Promise<UserProfileDetail> {
 const { data, error } = await supabase
 .from('user_profiles')
 .select(`
 *,
 manager:user_profiles!user_profiles_direct_manager_id_fkey(full_name)
 `)
 .eq('id', id)
 .single();

 if (error) throw error;
 if (!data) throw new Error('Không tìm thấy thông tin nhân sự');

 return {
 ...data,
 position_name: data.job_title || 'Chưa cập nhật',
 department_name: 'Chưa cập nhật', // Not available in current schema
 direct_manager: (data.manager as any)?.full_name || 'Không có',
 role_name: data.role_code || 'Nhân viên',
 account_status: data.is_active ? 'Hoạt động' : 'Đã khóa',
 status: data.is_active ? 'active' : 'suspended',
 } as UserProfileDetail;
 },

 async updateUserDetail(id: string, updates: Partial<UserProfileDetail>): Promise<void> {
 const { error } = await supabase
 .from('user_profiles')
 .update(updates)
 .eq('id', id);

 if (error) throw error;
 }
};
